import {lazy} from 'react';

export const RoomAsync = lazy(() =>
    import('./Room')
);
